var map = {
	"./cz.svg": "f428",
	"./de.svg": "1a15",
	"./en.svg": "90e4",
	"./es.svg": "f35d",
	"./fr.svg": "26da",
	"./it.svg": "8fb1",
	"./pl.svg": "b7d9",
	"./pt.svg": "1605",
	"./ro.svg": "595a",
	"./ru.svg": "4c2a",
	"./sv.svg": "a34b",
	"./tr.svg": "5aef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc43";